export default class ODASelector {
  static getOdaJobs = state => state.oda.entities.odaJobs;
  static getSelectedJobId = state => state.oda.ui.selectedJobId;
  static getTempSweptVariables = state => state.oda.ui.tempSweptVariables;
  static getOverviewFilters = state => state.oda.ui.overviewFilters;
}
